import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import { PaginationProps } from 'antd/lib/pagination';
import createPaginationStore from './pagination';
import createPreloadersStore from './preloaders';
import createFiltersStore from './filters';
import removeUndefinedFilters from '@helpers/removeUndefinedFilters';
import IUser from '../interfaces/IUser';
import IPost from '../interfaces/IPost';
import IComment from '../interfaces/IComment';

export const reset = createEvent('Spam complainers store reset');

const defaultFilters = {
  sort: 'id,desc',
};

export const getList = createEffect({
  name: 'getList',
  async handler(params?: {
    itemId: IPost['id'] | IComment['id'];
    mode: 'post' | 'comment';
    pagination?: PaginationProps;
    filters?: Record<string, any>;
  }) {
    const paginationParams: PaginationProps = {
      ...pagination.getState(),
      ...params?.pagination,
    };
    const { pageSize, current } = paginationParams;

    let filtersParams = filters.getState();
    if (params?.filters) {
      setFilters(params.filters);
      filtersParams = params.filters;
      paginationParams.current = 1;
    }

    const endpoint =
      params?.mode === 'comment' ? api.spam.showCommentComplainers : api.spam.showComplainers;

    const response = await request(endpoint, {
      urlParams: { itemId: params?.itemId },
      params: {
        paged: true,
        size: pageSize,
        page: (current || 1) - 1,
        ...defaultFilters,
        ...removeUndefinedFilters(filtersParams),
      },
    });
    return response;
  },
});

const { pagination, setPagination } = createPaginationStore({
  getList,
  listName: 'spam-complainers',
  resetEvent: reset,
  bodyPath: ['data', 'body'],
});

export { setPagination };

const preloaders = createPreloadersStore([getList]);

const { filters, setFilters } = createFiltersStore({
  listName: 'spam-complainers',
  deaultValues: defaultFilters,
  resetEvent: reset,
});

export { setFilters };

const list = createStore<IUser[]>([])
  .on(getList.done, (state, { result }) => result.data.body.content)
  .reset(reset);

const spamComplainers = combine({ preloaders, list, pagination, filters });

export default spamComplainers;
